import { IconButton } from '~/shared/ui'

export function ZoomControls({
  onZoomOut,
  onZoomIn,
  zoomOutDisabled,
  zoomInDisabled,
  fitToWidth,
  onFitToWidth,
}: {
  onZoomOut: () => void
  onZoomIn: () => void
  zoomOutDisabled: boolean
  zoomInDisabled: boolean
  fitToWidth: boolean
  onFitToWidth: () => void
}) {
  return (
    <div className="bg-content-highest-emphasis text-content-highest-emphasis-inverse absolute right-4 bottom-6 z-2 flex h-[56px] items-center justify-end gap-2 rounded-xl px-4 opacity-0 transition-opacity group-hover:opacity-100 focus-within:opacity-100">
      <IconButton
        className="text-inherit disabled:opacity-38"
        size="medium"
        container="small"
        materialIcon="remove"
        onClick={onZoomOut}
        disabled={zoomOutDisabled}
      />
      <IconButton
        className="text-inherit disabled:opacity-38"
        size="medium"
        container="small"
        materialIcon={fitToWidth ? 'zoom_out' : 'zoom_in'}
        onClick={onFitToWidth}
      />
      <IconButton
        className="text-inherit disabled:opacity-38"
        size="medium"
        container="small"
        materialIcon="add"
        onClick={onZoomIn}
        disabled={zoomInDisabled}
      />
    </div>
  )
}
